module.exports = __webpack_public_path__ + "static/media/IconCheck3.c03d6104.svg";